import React, {
	createContext,
	useContext,
	type ReactNode,
	type Dispatch,
	type SetStateAction,
} from 'react';

interface PackageModalContextValue {
	openModal: () => void;
	closeModal: () => void;
	isOpen: boolean;
	isCollapsed: boolean;
	collapseDetails: Dispatch<SetStateAction<boolean>>;
}

const PackageModalContext = createContext<PackageModalContextValue>({
	openModal: () => {},
	closeModal: () => {},
	isOpen: false,
	isCollapsed: false,
	collapseDetails: () => {},
});

export const usePackageModalContext = () => {
	const context = useContext(PackageModalContext);
	return context;
};

interface PackageModalProviderProps {
	children: ReactNode;
	openModal: () => void;
	closeModal: () => void;
	isOpen: boolean;
	isCollapsed: boolean;
	collapseDetails: Dispatch<SetStateAction<boolean>>;
}

export const PackageModalProvider = ({
	children,
	openModal,
	closeModal,
	isOpen,
	isCollapsed,
	collapseDetails,
}: PackageModalProviderProps) => {
	return (
		<PackageModalContext.Provider
			value={{ openModal, closeModal, isOpen, isCollapsed, collapseDetails }}
		>
			{children}
		</PackageModalContext.Provider>
	);
};
